import { decode, encode } from '@/utils/base64'

// 是否使用加密
const useEncode = false

const storage = {

  clear () {
    sessionStorage.clear()
  },

  setItem (key, value) {
    if (useEncode) {
      value = encode(value)
    }
    // 同时存储到 sessionStorage 和 localStorage
    sessionStorage.setItem(key, value)
    localStorage.setItem(key, value)
  },

  getItem (key) {
    // 优先从 localStorage 获取（支持跨标签页共享）
    let value = localStorage.getItem(key)
    if (!value) {
      value = sessionStorage.getItem(key)
    }
    if (useEncode) {
      value = decode(value)
    }
    return value
  },

  removeItem (key) {
    // 同时从 sessionStorage 和 localStorage 删除
    sessionStorage.removeItem(key)
    localStorage.removeItem(key)
  }
}

export default storage
